
export const GetBaseUrl = (fullUrl) => {
  const url = new URL(fullUrl);
  const baseUrl = `${url.protocol}//${url.hostname}${
    url.port ? `:${url.port}` : ""
  }`;
  const restOfUrl = `${url.pathname}${url.search}${url.hash}`;
  return baseUrl;
};
